import { Input as InputA } from 'antd';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../icon';

type P = {
  hasSearch?: boolean;
} & ComponentProps<typeof InputA>;

const Input = ({ hasSearch, placeholder, ...rest }: P) => {
  const { t } = useTranslation();

  return (
    <InputA
      allowClear={hasSearch}
      placeholder={typeof placeholder === 'string' ? t(placeholder) : placeholder}
      prefix={hasSearch ? <Icon icon="search-2-line" /> : undefined}
      size="large"
      {...rest}
    />
  );
};

export default Input;
